"use client"

import { useEffect } from "react"

export function BuildStamp() {
  useEffect(() => {
    const buildSHA = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || process.env.NEXT_PUBLIC_BUILD_SHA || "development"
    const buildBranch = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF || "unknown"

    console.log(`🏗️ CONTACT BOOK BUILD: ${buildSHA.substring(0, 8)} (${buildBranch})`)
  }, [])

  return null
}
